import React from 'react';
import { DataGrid, WarningDialog } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { SensorTbltMsgsReturn } from '@Hooks';
import { TestableFields } from '@Types/peek';

interface SensorTroubleShootProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	sensorTbltingMsgs: SensorTbltMsgsReturn;
}

const SensorTroubleShootDialog = (props: SensorTroubleShootProps) => {
	const { t } = useGlobalization();
	const { open, onConfirm, onCancel } = props;

	const MAPPINGS: Record<TestableFields, string> = {
		channelField: t('Channel Field'),
		dataSource: t('Data Source'),
		dateField: t('Date Field'),
		idField: t('Id Field'),
		tableName: t('Table Name'),
		tagValue: t('Tag Value'),
	};

	const columns = [
		{ field: 'field', headerName: t('FIELD'), width: 150 },
		{ field: 'error', headerName: t('RESULT'), width: 350 },
	];

	const rows = Object.entries(props.sensorTbltingMsgs.messages).map(
		([key, val], id) => ({
			id: `tblt-error-${id}`,
			field: MAPPINGS[key as TestableFields],
			error: val,
		}),
	);

	return (
		<WarningDialog
			title={t('Troubleshooting Results')}
			open={open}
			cancelText={t('Ok')}
			onCancel={onCancel}
			dividers="both">
			<Grid container spacing={4}>
				<div style={{ width: '500px', padding: '24px' }}>
					<DataGrid rows={rows} columns={columns} />
				</div>
			</Grid>
		</WarningDialog>
	);
};

export default SensorTroubleShootDialog;
